var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ALERTS_FORM_ATTRIBUTE_CHANGE, ALERTS_FORM_CLOSE_ACCORDION, ALERTS_FORM_DELIVERY_CHANGE, ALERTS_FORM_FORCE_CLOSE_ACCORDION, ALERTS_FORM_INITIALIZE, ALERTS_FORM_OPEN_ACCORDION, ALERTS_FORM_PREFERENCE_UPDATE_ERROR, ALERTS_FORM_RESET_DATA, ALERTS_FORM_SET_ERROR, ALERTS_FORM_SET_IS_LOADING, ALERTS_FORM_SET_SHOULD_SHOW_TERMS_CONDITIONS } from '../actionTypes';
var initialState = {};
export var initialFormState = {
    showTermsAndConditions: false,
    isDirty: false,
    isExpanded: false,
    forceClose: true,
    isLoading: false,
    dataErrors: [],
    apiError: ''
};
var alertsForm = function (
// eslint-disable-next-line default-param-last, @typescript-eslint/default-param-last
state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (state === void 0) { state = initialState; }
    var payload = action.payload;
    var updateId = payload === null || payload === void 0 ? void 0 : payload.id;
    var currentAlertForm = state[updateId];
    switch (action.type) {
        case ALERTS_FORM_SET_ERROR: {
            return __assign(__assign({}, state), (_a = {}, _a[updateId] = __assign(__assign({}, currentAlertForm), { dataErrors: __spreadArray([], payload.dataErrors, true) }), _a));
        }
        case ALERTS_FORM_CLOSE_ACCORDION: {
            return __assign(__assign({}, state), (_b = {}, _b[updateId] = __assign(__assign({}, currentAlertForm), { isExpanded: false }), _b));
        }
        case ALERTS_FORM_OPEN_ACCORDION: {
            return __assign(__assign({}, state), (_c = {}, _c[updateId] = __assign(__assign({}, currentAlertForm), { isExpanded: true, forceClose: false }), _c));
        }
        case ALERTS_FORM_FORCE_CLOSE_ACCORDION: {
            return __assign(__assign({}, state), (_d = {}, _d[updateId] = __assign(__assign({}, currentAlertForm), { isExpanded: false, forceClose: true }), _d));
        }
        case ALERTS_FORM_ATTRIBUTE_CHANGE: {
            return __assign(__assign({}, state), (_e = {}, _e[updateId] = __assign(__assign({}, currentAlertForm), { attributes: payload.attributes, dataErrors: payload.dataErrors, isDirty: payload.isDirty }), _e));
        }
        case ALERTS_FORM_DELIVERY_CHANGE: {
            return __assign(__assign({}, state), (_f = {}, _f[updateId] = __assign(__assign({}, currentAlertForm), { delivery: payload.delivery, dataErrors: payload.dataErrors, isDirty: payload.isDirty }), _f));
        }
        case ALERTS_FORM_SET_IS_LOADING: {
            return __assign(__assign({}, state), (_g = {}, _g[updateId] = __assign(__assign({}, currentAlertForm), { isLoading: payload.isLoading }), _g));
        }
        case ALERTS_FORM_PREFERENCE_UPDATE_ERROR: {
            return __assign(__assign({}, state), (_h = {}, _h[updateId] = __assign(__assign({}, currentAlertForm), { apiError: payload.apiError }), _h));
        }
        case ALERTS_FORM_INITIALIZE: {
            return __assign(__assign({}, state), (_j = {}, _j[updateId] = __assign(__assign({}, initialFormState), { delivery: __assign({}, payload.delivery), attributes: __assign({}, payload.attributes) }), _j));
        }
        case ALERTS_FORM_RESET_DATA: {
            return __assign(__assign({}, state), (_k = {}, _k[updateId] = __assign(__assign({}, initialFormState), { 
                // We keep the current value instead of the initial value to allow the UI to determine when to show the terms and conditons
                showTermsAndConditions: currentAlertForm.showTermsAndConditions, delivery: __assign({}, payload.delivery), attributes: __assign({}, payload.attributes) }), _k));
        }
        case ALERTS_FORM_SET_SHOULD_SHOW_TERMS_CONDITIONS: {
            return __assign(__assign({}, state), (_l = {}, _l[updateId] = __assign(__assign({}, currentAlertForm), { showTermsAndConditions: payload.showTermsAndConditions }), _l));
        }
        default:
            return state;
    }
};
export default alertsForm;
